import firebase from 'firebase/compat/app';
import { v4 as uuidv4 } from 'uuid';
import 'firebase/compat/messaging';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { insertNotificationDevice } from './services/public/public.service';

const firebaseConfig = {
    apiKey: "AIzaSyBI05evgpIIMVg4eetPsDuefQYtRNxU2n8",
    authDomain: "propacity-for-brokers.firebaseapp.com",
    projectId: "propacity-for-brokers",
    storageBucket: "propacity-for-brokers.appspot.com",
    messagingSenderId: "574302838332",
    appId: "1:574302838332:web:d1528c52b003e1c752ed39",
    measurementId: "G-0255FB0B5M"
};

const firebaseApp = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);

export const fetchToken = async (setTokenFound) => {
    try {
        const supported = await isSupported();
        if (!supported) {
            console.log('Firebase messaging is not supported in this browser environment.');
            setTokenFound(false);
            return null;
        }
        const messaging = getMessaging(firebaseApp);
        const currentToken = await getToken(messaging, { vapidKey: 'BP45Ot81ya2vG8P-d0VIUEna8g9AoEyRy55CeCN0xVZRbwDehtDb8FrxhX10Z8vgtVI5iEmzxwJk1VuyJ_0FNwQ' });
        if (currentToken) {
            let deviceId = localStorage.getItem('deviceId');
            let authToken = localStorage.getItem('authToken');

            if (!deviceId) {
                deviceId = uuidv4();
                localStorage.setItem('deviceId', deviceId);
            }
            const payload = {
                firebaseToken: currentToken,
                device_id: deviceId
            }
            if (authToken) {
                await insertNotificationDevice(payload)
            }
            setTokenFound(true);
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            setTokenFound(false);
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
        setTokenFound(false);
    }
}

export const onMessageListener = () =>
    new Promise(async (resolve, reject) => {
        try {
            const supported = await isSupported();
            if (!supported) {
                console.log('Firebase messaging is not supported, listener skipped.');
                return;
            }
            const messaging = getMessaging(firebaseApp);
            onMessage(messaging, (payload) => {
                resolve(payload);
            });
        } catch (err) {
            reject(err);
        }
    });